<template>
  <gj-modal
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    size="normal"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>
      <span>标签数据导出</span>
    </template>
    <template #content>
      <el-form ref="form" :model="form" label-width="74px">
        <el-form-item
          label="日期范围"
          prop="dateRange"
          :rules="[
            {
              required: true,
              message: '请选择日期范围',
              trigger: 'change',
            },
          ]">
          <gj-date-picker-active
            v-model="form.dateRange"
            type="daterange"
            :maxDayLength="31"
            :shortcuts="['今天', '昨天', '近7天', '近30天', '本月', '上月']">
          </gj-date-picker-active>
          <span class="color999 gj-ml10">(最多支持31天数据导出)</span>
        </el-form-item>
        <el-form-item
          label="导出规则"
          prop="ruleId"
          style="margin-bottom: 5px">
          <gj-select
            v-model="form.ruleId"
            :options="options"
            placeholder="不限类型"
            style="width: 210px"
          ></gj-select>
        </el-form-item>
        <el-form-item v-if="form.ruleId === 1">
          <gj-country-server-select
            v-model="form.countryMarketValue"
            style="width: 210px">
          </gj-country-server-select>
        </el-form-item>
        <el-form-item v-if="form.ruleId === 2">
          <gj-charger-select
            v-model="form.chargeIdList"
            collapse-tags
            placeholder="选择负责人"
            active
            style="width: 210px">
          </gj-charger-select>
        </el-form-item>
        <el-form-item v-if="form.ruleId === 3">
          <gj-category-select
            v-model="form.categoryIds"
            placeholder="选择品类"
            multiple
            active
            style="width: 210px"
          ></gj-category-select>
        </el-form-item>
        <el-form-item v-if="form.ruleId === 4">
          <gj-select
            v-model="form.source"
            :options="tagSourceOptions"
            placeholder="选择来源"
            style="width: 210px">
          </gj-select>
        </el-form-item>
        <el-form-item v-if="form.ruleId === 5">
          <gj-textarea
            v-model="form.asin"
            :styles="{ height: '120px', width: '210px' }"
            placeholder="一行一项，回车换行，最多查询200项"
            class="form-input"
          >
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { modalMixIn, responseMixin, formRuleMixin } from "../../../../../minxins";

export default {
  name: "app-tag-export-modal",
  mixins: [modalMixIn, responseMixin, formRuleMixin],
  data() {
    return {
      confirmLoading: false,
      options: [
        {text: '按国家店铺导出', id: 1},
        {text: '按负责人导出', id: 2},
        {text: '按品类导出', id: 3},
        {text: '按标签来源导出', id: 4},
        {text: '按ASIN导出', id: 5}
      ],
      tagSourceOptions: [
        {text: 'NR', id: 1},
        {text: 'NF', id: 2},
        {text: 'contact buyer', id: 3},
        {text: 'email', id: 4},
        {text: 'revie', id: 5},
        {text: 'feedbac', id: 6},
        {text: '退货订单', id: 7}
      ],
      form: {
        dateRange: '',
        ruleId: '',
        countryMarketValue: null,
        chargeIdList: [],
        categoryIds: '',
        source: '',
        asin: ''
      }
    };
  },
  methods: {
    confirm() {
      if (this.$gjFormValidate()) {
        // this.confirmLoading = true;
        this.$emit("exportSucc");
      }
    }
  },
};
</script>

<style scoped>.upload-btn {
  margin-bottom: 16px;
}
</style>
